import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  IonIcon,
} from "@ionic/react";
import React from "react";
import { homeOutline } from "ionicons/icons";
import {
  printOutline,
  calendarOutline,
  medicalOutline,
  checkmarkCircleOutline,
  closeCircleOutline,
  hourglass,
  filterOutline,
  addCircleOutline,
} from "ionicons/icons";

import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import ModernDesplegable from "../../components/basicsComponents/ModernDesplegable/ModernDesplegable";
import {
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import { Typography } from "@mui/joy";
import { useTurnosPaciente } from "./useTurnosPaciente";
import "./TurnosPaciente.css";


export default function TurnosPaciente() {
    // Estado para abrir/cerrar el filtro de especialidad y prestador
    const [openEspecialidad, setOpenEspecialidad] = React.useState(false);
    const [openPrestador, setOpenPrestador] = React.useState(false);
  const [filtroCard, setFiltroCard] = React.useState('');
  const [especialidadFiltro, setEspecialidadFiltro] = React.useState(-1);
  const [prestadorFiltro, setPrestadorFiltro] = React.useState(-1);
  const {
    usuario,
    cargando,
    listadoTurnos,
    listadoTurnosFiltrados,
    turnoSeleccionado,
    abrirModalCancelarReserva,
    abrirComprobanteTurno,
    setAbrirModalCancelarReserva,
    handleClickSeleccionarTurno,
    handleClickCancelarReserva,
    handleClickComprobanteTurno,
    handleClickReservarTurnoPrestador,
    toggleComprobanteTurno,
  } = useTurnosPaciente();

  const { formatearFechaTurno, obtenerEstadoTurno } = require("./turnosPacienteUtils");

  const getEstadoConfig = (estado) => {
    const configs = {
      'Confirmado': {
        icon: checkmarkCircleOutline,
        class: 'confirmado',
        color: '#43e97b'
      },
      'Pendiente': {
        icon: hourglass,
        class: 'pendiente', 
        color: '#ffc409'
      },
      'Cancelado': {
        icon: closeCircleOutline,
        class: 'cancelado',
        color: '#ff6b6b'
      },
      'Asistido': {
        icon: checkmarkCircleOutline,
        class: 'asistido',
        color: '#3e6bb5'
      }
    };
    return configs[estado] || configs['Pendiente'];
  };
  // Filtrar los turnos según el filtro de card
const turnosFiltradosPorCard = React.useMemo(() => {
  let filtrados = listadoTurnosFiltrados;
  if (especialidadFiltro !== -1) {
    filtrados = filtrados.filter(t => t.especialidad === especialidadFiltro);
  }
  if (prestadorFiltro !== -1) {
    filtrados = filtrados.filter(t => t.prestadorCod === prestadorFiltro);
  }
  if (!filtroCard) return filtrados;
  return filtrados.filter(t => {
    const estado = obtenerEstadoTurno(t);
    return estado === filtroCard;
  });
}, [filtroCard, listadoTurnosFiltrados, especialidadFiltro, prestadorFiltro]);
  const renderTurnosModernos = () => (
    <div className="tech-turnos-lista">
      {turnosFiltradosPorCard && Array.isArray(turnosFiltradosPorCard) && turnosFiltradosPorCard.map((turno) => {
        const estado = obtenerEstadoTurno(turno);
        const estadoConfig = getEstadoConfig(estado);

        return (
          <div key={turno.codigo} className="tech-turno-card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '24px' }}>
            <div style={{ flex: 2, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1a2a3a', marginBottom: 4 }}>{turno.prestadorNom} {turno.especialidadNom ? `- ${turno.especialidadNom}` : ''}</div>
              <div style={{ fontSize: '0.95rem', color: '#222', marginBottom: 2 }}>
                <span style={{ fontSize: '1.2rem' }}>📅</span>{' '}
                {formatearFechaTurno(turno.fecha, turno.hora)}
              </div>
            </div>

            <div style={{ flex: 1, minWidth: 0, textAlign: 'center' }}>
              {turno.mutualNom && (
                <div style={{ fontSize: '0.9rem', color: '#4a4a4a', marginBottom: 2 }}>{turno.mutualNom}</div>
              )}
              <div style={{ fontSize: '0.9rem', color: '#4a4a4a', marginBottom: 2 }}>
                Estado:
                {estado === 'Cancelado' ? (
                  <span style={{
                    display: 'inline-block',
                    background: 'linear-gradient(90deg, #ffb86b 0%, #ff6b6b 100%)',
                    color: '#fff',
                    fontWeight: 700,
                    borderRadius: '16px',
                    padding: '4px 16px',
                    marginLeft: '8px',
                    fontSize: '0.85rem',
                    boxShadow: '0 2px 8px rgba(255,107,107,0.10)'
                  }}>{estado}</span>
                ) : estado === 'Asistido' ? (
                  <span style={{
                    display: 'inline-block',
                    background: 'linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)',
                    color: '#fff',
                    fontWeight: 700,
                    borderRadius: '16px',
                    padding: '4px 16px',
                    marginLeft: '8px',
                    fontSize: '0.85rem',
                    boxShadow: '0 2px 8px rgba(67,233,123,0.10)'
                  }}>{estado}</span>
                ) : estado === 'Pendiente' ? (
                  <span style={{
                    display: 'inline-block',
                    background: 'linear-gradient(90deg, #b3cff7 0%, #3e6bb5 100%)',
                    color: '#222',
                    fontWeight: 700,
                    borderRadius: '16px',
                    padding: '4px 16px',
                    marginLeft: '8px',
                    fontSize: '0.85rem',
                    boxShadow: '0 2px 8px rgba(42, 86, 163, 0.10)'
                  }}>{estado}</span>
                ) : (
                  <span style={{ fontWeight: 600, marginLeft: '8px' }}>{estado}</span>
                )}
              </div>
            </div>

            {/* Columna 3: Acciones */}
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>
              <button 
                className="tech-action-btn comprobante"
                onClick={() => handleClickComprobanteTurno(turno)}
              >
                <IonIcon icon={printOutline} />
                <span>Comprobante</span>
              </button>
              <button 
                className="tech-action-btn reservar"
                onClick={() => handleClickReservarTurnoPrestador(turno.prestadorCod)}
              >
                <IonIcon icon={addCircleOutline} />
                <span>Reservar Turno</span>
              </button>
              {(estado === 'Confirmado' || estado === 'Pendiente') && (
                <button 
                  className="tech-action-btn danger"
                  onClick={() => handleClickSeleccionarTurno(turno)}
                >
                  <IonIcon icon={closeCircleOutline} />
                  <span>Cancelar</span>
                </button>
              )}
            </div>
          </div>
        );
      })}
      
      {(!listadoTurnosFiltrados || !Array.isArray(listadoTurnosFiltrados) || listadoTurnosFiltrados.length === 0) && (
        <div className="tech-empty-state">
          <div className="tech-empty-icon">
            <IonIcon icon={calendarOutline} />
          </div>
          <Typography className="tech-empty-title">
            No tienes turnos programados
          </Typography>
          <Typography className="tech-empty-subtitle">
            Cuando reserves un turno, aparecerá aquí para que puedas gestionarlo.
          </Typography>
        </div>
      )}
    </div>
  );

const prestadorMasConsultado = (() => {
  if (!Array.isArray(listadoTurnos) || listadoTurnos.length === 0) return null;
  const conteo = {};
  listadoTurnos.forEach(t => {
    if (t.prestadorNom) conteo[t.prestadorNom] = (conteo[t.prestadorNom] || 0) + 1;
  });
  const max = Object.entries(conteo).sort((a, b) => b[1] - a[1])[0];
  if (!max) return null;
  return {
    nombre: max[0],
    cantidad: max[1]
  };
})();

const especialidadMasAsistida = (() => {
  if (!Array.isArray(listadoTurnos) || listadoTurnos.length === 0) return null;
  const conteo = {};
  listadoTurnos.forEach(t => {
    if (obtenerEstadoTurno(t) === 'Asistido' && t.especialidadNom) conteo[t.especialidadNom] = (conteo[t.especialidadNom] || 0) + 1;
  });
  const max = Object.entries(conteo).sort((a, b) => b[1] - a[1])[0];
  if (!max) return null;
  return {
    nombre: max[0],
    cantidad: max[1]
  };
})();

  const handleVolverInicio = () => {
    window.location.href = '/portal/Inicio';
  };

  return (
    <div className="tech-turnos-container">
      {cargando && <LoadingBackdrop visualizar={cargando} />}

      <div className="tech-turnos-header">
        <div className="turnos-header-row">
          <h1 className="tech-page-title">
            Resumen de Mis Turnos
          </h1>
          <button className="tech-action-btn volver-inicio" onClick={handleVolverInicio}>
            <button 
              onClick={handleVolverInicio}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 20px",
                backgroundColor: "white",
                border: "2px solid #1976f3",
                borderRadius: "12px",
                color: "#1976f3",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(42, 86, 163, 0.10)"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#2A56A3";
                e.target.style.color = "white";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(42, 86, 163, 0.18)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#2A56A3";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(42, 86, 163, 0.10)";
              }}
            >
              <IonIcon icon={homeOutline} style={{ fontSize: "18px" }} />
              <span>Volver al inicio</span>
            </button>
          </button>
        </div>

        <div className="turnos-stats-row">
          <div className={`turnos-stat-card${filtroCard === '' ? ' active' : ''}`} onClick={() => setFiltroCard('')} style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Haz click para ver el total de turnos</span>
            <span className="stat-icon" style={{ fontSize: '2.5rem' }}>📅</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">{listadoTurnos?.length || 0}</span>
              <span className="stat-label" style={{ color: '#1976f3' }}>Total Turnos</span>
            </div>
          </div>
          <div className={`turnos-stat-card${filtroCard === 'Pendiente' ? ' active' : ''}`} onClick={() => setFiltroCard('Pendiente')} style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Haz click para ver los turnos pendientes</span>
            <span className="stat-icon pendiente" style={{ fontSize: '2.5rem' }}>⏳</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">
                {listadoTurnos?.filter(t => obtenerEstadoTurno(t) === 'Pendiente').length || 0}
              </span>
              <span className="stat-label" style={{ color: '#1976f3' }}>Pendientes</span>
            </div>
          </div>
          <div className={`turnos-stat-card${filtroCard === 'Asistido' ? ' active' : ''}`} onClick={() => setFiltroCard('Asistido')} style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Haz click para ver los turnos asistidos</span>
            <span className="stat-icon asistido" style={{ fontSize: '2.5rem' }}>✅</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">
                {listadoTurnos?.filter(t => obtenerEstadoTurno(t) === 'Asistido').length || 0}
              </span>
              <span className="stat-label" style={{ color: '#1976f3' }}>Asistidos</span>
            </div>
          </div>
          <div className={`turnos-stat-card${filtroCard === 'Cancelado' ? ' active' : ''}`} onClick={() => setFiltroCard('Cancelado')} style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Haz click para ver los turnos cancelados</span>
            <span className="stat-icon cancelado" style={{ fontSize: '2.5rem' }}>❌</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">
                {listadoTurnos?.filter(t => obtenerEstadoTurno(t) === 'Cancelado').length || 0}
              </span>
              <span className="stat-label" style={{ color: '#1976f3' }}>Cancelados</span>
            </div>
          </div>
          {/* Card: Prestador más consultado */}
          <div className="turnos-stat-card" style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Prestador con más consultas</span>
            <span className="stat-icon" style={{ fontSize: '2.5rem' }}>👨‍⚕️</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">{prestadorMasConsultado?.cantidad || 0}</span>
              <span className="stat-label" style={{ fontSize: '0.95rem', color: '#1976f3' }}>{prestadorMasConsultado?.nombre || 'Sin datos'}</span>
            </div>
            <span className="stat-label" style={{ fontSize: '0.85rem', color: '#888', display: 'block', marginTop: '4px', textAlign: 'center', width: '100%' }}>Prestador más consultado</span>
          </div>
          <div className="turnos-stat-card" style={{ cursor: 'pointer' }}>
            <span className="turnos-tooltip">Especialidad con más asistencias</span>
            <span className="stat-icon" style={{ fontSize: '2.5rem' }}>🏥</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span className="stat-number">{especialidadMasAsistida?.cantidad || 0}</span>
              <span className="stat-label" style={{ fontSize: '0.95rem', color: '#1976f3' }}>{especialidadMasAsistida?.nombre || 'Sin datos'}</span>
            </div>
            <span className="stat-label" style={{ fontSize: '0.85rem', color: '#888', display: 'block', marginTop: '4px', textAlign: 'center', width: '100%' }}>Especialidad más asistida</span>
          </div>
        </div>
      </div>

      {listadoTurnos === null || listadoTurnos.length <= 0 ? (
        <div className="tech-empty-state">
          <div className="empty-icon">
            <IonIcon icon={medicalOutline} />
          </div>
          <h3>No tienes turnos registrados</h3>
          <p>Cuando tengas turnos programados, aparecerán aquí</p>
          <button 
            className="tech-action-btn primary"
            onClick={() => {/* Navigate to new appointment */}}
          >
            <IonIcon icon={addCircleOutline} />
            <span>Solicitar Turno</span>
          </button>
        </div>
      ) : (
        <>
          {/* Filtros modernos */}
          <div className="tech-filtros-container">
            <div className="tech-filtros-header">
              <h2 className="tech-page-title secondary">
                <IonIcon icon={filterOutline} className="filter-icon" style={{ color: '#1976f3' }} />
                <span style={{ color: '#1976f3' }}>Aquí puedes filtrar y buscar entre tus turnos</span>
              </h2>
            </div>
            
            <div className="tech-filtros-grid">
              
              <div className="tech-filtros-row" style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                <div className="tech-filter-group glass-filter">
                  <ModernDesplegable
                    array={(() => {
                      const especialidadesTurnos = listadoTurnosFiltrados
                        .map(t => ({ codigo: t.especialidad, text: t.especialidadNom }))
                        .filter(e => e.codigo !== undefined && e.text !== undefined);
                      const mapa = new Map();
                      especialidadesTurnos.forEach(e => {
                        if (!mapa.has(e.codigo)) mapa.set(e.codigo, e.text);
                      });
                      const lista = Array.from(mapa.entries()).map(([codigo, text]) => ({ codigo, text }));
                      return [{ codigo: -1, text: 'Mostrar todos' }, ...lista];
                    })()}
                    placeholder={"Seleccione especialidad"}
                    value={especialidadFiltro}
                    handleChange={(value) => {
                      setEspecialidadFiltro(value);
                      setOpenEspecialidad(false);
                    }}
                    label="Especialidad"
                    id="especialidad"
                    isOpen={openEspecialidad}
                    setIsOpen={setOpenEspecialidad}
                    emoji="🏥"
                    color="#2A56A3"
                  />
                </div>
                <div className="tech-filter-group glass-filter">
                  <ModernDesplegable
                    array={(() => {
                      const prestadoresTurnos = listadoTurnos
                        .map(t => ({ codigo: t.prestadorCod, text: t.prestadorNom }))
                        .filter(e => e.codigo !== undefined && e.text !== undefined && e.text !== null);
                      const mapa = new Map();
                      prestadoresTurnos.forEach(e => {
                        if (e.codigo !== null && !mapa.has(e.codigo)) mapa.set(e.codigo, e.text);
                      });
                      const lista = Array.from(mapa.entries()).map(([codigo, text]) => ({ codigo, text }));
                      return [{ codigo: -1, text: 'Mostrar todos' }, ...lista];
                    })()}
                    placeholder={"Seleccione prestador"}
                    value={prestadorFiltro}
                    handleChange={(value) => { setPrestadorFiltro(value); setOpenPrestador(false); }}
                    label="Prestador"
                    id="prestador"
                    isOpen={openPrestador}
                    setIsOpen={setOpenPrestador}
                    emoji="👨‍⚕️"
                    color="#764ba2"
                  />
                </div>
              </div>
            </div>
            <br />
 <br />
            <div className="tech-filtros-adicionales">
            </div>
          </div>

           <h2 className="tech-page-title secondary">
                <IonIcon icon={filterOutline} className="filter-icon" style={{ color: '#1976f3' }} />
                <span style={{ color: '#1976f3' }}>Aquí tu lista de turnos seleccionada.</span>
              </h2>
          {renderTurnosModernos()}

          <DialogoConfirmacion
            titulo="Cancelar turno"
            texto={`Ha decidido cancelar el turno con el/la profesional ${
              turnoSeleccionado?.prestadorNom || ''
            }, con especialidad en ${
              turnoSeleccionado?.especialidadNom || ''
            }, para el día ${obtenerNombreDia(
              dayjs().format("dddd")
            )} ${dayjs().format("DD")} de ${dayjs().format(
              "MMMM, YYYY"
            )} a las ${dayjs().format("HH:mm")}, ¿Esta seguro/a de ello?`}
            open={abrirModalCancelarReserva}
            setOpen={setAbrirModalCancelarReserva}
            handleClickConfirmar={handleClickCancelarReserva}
            colorBotonNo="danger"
            colorBotonSi="success"
            textoBotonNo="No"
            textoBotonSi="Si, cancelo"
          />
          
          <ComprobanteTurno
            turno={turnoSeleccionado}
            abrir={abrirComprobanteTurno}
            togleAbrirCerrarComprobanteTurno={toggleComprobanteTurno}
            paciente={usuario}
          />
          
          <CustomToast
            openToast={false}
            onDidDismiss={() => {}}
            message={""}
            colorNotificacion={""}
          />
        </>
      )}
    </div>
  );
}
